import { render, staticRenderFns } from "./Divisive.vue?vue&type=template&id=04b92d46&scoped=true"
import script from "./Divisive.vue?vue&type=script&lang=js"
export * from "./Divisive.vue?vue&type=script&lang=js"
import style0 from "./Divisive.vue?vue&type=style&index=0&id=04b92d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b92d46",
  null
  
)

export default component.exports